import PopupTimeRange from 'components/PopupTimeRange'
import {dateFilter, timeIsValid} from 'helpers/date'

export default {
  components: {PopupTimeRange},

  methods: {
    async onContextMenuDailyPeople(e, row, y) {
      this.$refs.contextMenu.show(e, [{
        label: '稼働計画を編集',
        onClick: () => {
          const {model} = row
          this.$refs.popupDailyPeople.show(model.begin_time, model.end_time, {model, y,
            title: `${model.name} ${dateFilter(this.date)}`,
            regular: timeIsValid(model.regular_begin_time, model.regular_end_time)
              ? {begin: model.regular_begin_time, end: model.regular_end_time}
              : null,
          })
        },
      }])
    },

    async dailyPeopleOff(params) {
      await this.dailyPeopleConfirm('', '', params)
    },

    async dailyPeopleRegular(params) {
      const {regular} = params
      await this.dailyPeopleConfirm(regular.begin, regular.end, params)
    },

    async dailyPeopleConfirm(begin_time, end_time, { model }) {
      try {
        await this.updateDailyPeople(model, begin_time, end_time)
        this.$refs.popupDailyPeople.hide()
      }
      catch(e) {this.$handler(e)}
    },

    async updateDailyPeople(model, begin_time, end_time) {
      if (model != null) {
        const id = model.id
        if (id != null) {
          const data = { begin_time, end_time }
          const diff = Object.entries(data).reduce((a, [k, v]) => ({...a, ...v !== model[k] ? {[k]: v} : {}}), {})
          if(Object.keys(diff).length !== 0) {
            await this.axios.put('/api/daily_people/' + id, diff)
            await this.refresh()
          }
        }
      }
    },
  },
}
